import { splitEventParameters } from "./google-analytics-4.fn";
import type { EventData, GA4EventParameters } from "./google-analytics-4.type";

declare global {
	interface Window {
		dataLayer: any[];
	}
}

// Fixed variant: there is no AB test on the portal.
const VARIANT = "A";

/**
 * page_init sends these once and later events must leave them alone: nulling them would erase the identity
 * the container reads from the dataLayer model. pageInit.test.ts pins that page_init sends nothing beyond this set.
 */
export const PERSISTENT_PARAMETER_KEYS = ["user_id", "email", "first_name", "last_name", "consultant_id"];

export const Measurement = (() => {
	// Every previously pushed parameter must be nulled in the next push, or the previous event's value leaks into it.
	const pushedParameterKeys: Set<string> = new Set();
	let signedIn = false;

	function setSignedIn(value: boolean): void {
		signedIn = value;
	}

	function generateId(prefix: string): string {
		return `${prefix}-${crypto.randomUUID()}`;
	}

	function sendEvent(event: string, model?: GA4EventParameters): EventData[] {
		const eventList = splitEventParameters(event, {
			...model,
			// The spec requires the string "true"/"false" here, explicitly not a boolean.
			isSignedIn: signedIn ? "true" : "false",
			variant: VARIANT,
		});

		eventList.forEach((item) => {
			const nullReset = Object.fromEntries([...pushedParameterKeys].map((key) => [key, null]));

			const eventData = {
				event: item.event,
				...item.eventModel,
			};

			Object.keys(eventData).forEach((key) => {
				if (!PERSISTENT_PARAMETER_KEYS.includes(key)) {
					pushedParameterKeys.add(key);
				}
			});

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				...nullReset,
				...eventData,
			});
		});

		return eventList;
	}

	return {
		sendEvent,
		generateId,
		setSignedIn,
	};
})();
